import { AsYouType } from 'libphonenumber-js'

export function clearNonNumericValues(value: string): string {
  return value.replace(/\D/g, '')
}

// There's a bug in the AsYouType library that apparently
// makes the input not being able to remove parenthesis
// that's why the min length for parsing is 3 as the last
// parenthesis in the phone number is at the 5th position in the US
export const parsePhoneValue = (text: string) => {
  if (text.length > 5) {
    return new AsYouType('US').input(text)
  }

  return text
}
